import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  styled,
} from '@mui/material';


const ministeres = [
  {
    title: "Ministère de la Santé publique",
    link: "/MinistereSante",
    description: "Accédez aux statistiques sanitaires récentes et aux données sur les efforts de lutte contre le VIH/SIDA, les maladies infectieuses, et les initiatives de santé publique."
  },
  {
    title: "Ministère du Travail, de la Fonction Publique et de la Sécurité Sociale",
    link: "/MinistereFonctionPublique",
    description: "Découvrez les données statistiques concernant l'emploi, la gestion des ressources humaines, et les politiques de développement dans le secteur public."
  },
  {
    title: "Ministère de l'Education Nationale et de la Recherche Scientifique",
    link: "/MinistereEducation",
    description: "Explorez les statistiques et analyses concernant le système éducatif, les taux de scolarisation, et les réformes pédagogiques au Burundi."
  },
  {
    title: "Ministère de l'Intérieur, du Développement Communautaire et de la Sécurité Publique",
    link: "/MinistereInterieur",
    description: "Consultez les données pertinentes sur la sécurité nationale, l'administration locale, la gouvernance, et les efforts de consolidation de la paix."
  },
  {
    title: "Ministère des Infrastructures,des Logements Sociaux, des Transports et  de l'Equipement ",
    link: "/MinistereInfrastructures",
    description: "Renseignez-vous sur les projets d'infrastructures, leur état, les investissements en cours, et leur impact économique sur le développement local."
  },
  {
    title: "Ministère de la Justice, des Droits de la Personne Humaine et du Genre",
    link: "/MinistereJustice",
    description: "Accédez aux statistiques concernant le système judiciaire, les réformes législatives, et les droits humains."
  },
  {
    title: "Ministère de l'Environnement, de l'Agriculture et de l'Elevage",
    link: "/MinistereAgriculture",
    description: "Découvrez les données sur la production agricole, les techniques d'irrigation, et les politiques alimentaires pour assurer la sécurité alimentaire."
  },
  {
    title: "Ministère  de la Communication et des Médias",
    link: "/MinistereCommunication",
    description: "Examinez les statistiques sur les médias, les nouvelles technologies, et les enjeux de communication à l'ère numérique."
  },
  {
    title: "Ministère des Affaires Etrangères, de l'Intégration Régionale et de la Coopération au Développement",
    link: "/MinistereEAC",
    description: "Consultez les statistiques produites sur l'intégration régionale, les initiatives pour la jeunesse, les développements sportifs, et les activités culturelles en Afrique de l'Est."
  },
];



const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: `0px 4px 10px rgba(0, 0, 0, 0.1)`
  },
}));

const StyledCardActionArea = styled(CardActionArea)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2),
  '&:last-child': {
    paddingBottom: theme.spacing(2),
  },
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  color: '#388E3C', 
  fontWeight: 'bold',
  marginBottom: theme.spacing(1),
}));

const DescriptionTypography = styled(Typography)(({ theme }) => ({
  color: '#555',
}));

function Ministeres() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
      <NavigationBar />
      <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Statistiques sectorielles du Burundi
        </Typography>

        <Typography variant="body1" align="justify" >
        La centralisation des statistiques officielles produites par les institutions nationales, s'appuyant sur des sources gouvernementales et partenaires internationaux.
        </Typography>

        <Grid container spacing={1} style={{ marginTop: '20px' }}>
          {ministeres.map((ministere, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <StyledCard>
                <StyledCardActionArea href={ministere.link}>
                  <StyledCardContent>
                    <TitleTypography variant="h6" component="div">
                      {ministere.title}
                    </TitleTypography>
                    <DescriptionTypography variant="body2">
                      {ministere.description}
                    </DescriptionTypography>
                  </StyledCardContent>
                </StyledCardActionArea>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
      </Container>
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default Ministeres;